var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockerMIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 168,
    viewBox: "0 0 189 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 75.7528V116.362C0.5 121.912 3.4679 127.039 8.28119 129.803L68.1644 164.192C72.898 166.91 78.7124 166.938 83.472 164.266L180.589 109.735C185.475 106.991 188.5 101.824 188.5 96.2196V53.413C188.5 47.9369 185.611 42.8673 180.899 40.0766L120.233 4.1453C115.318 1.23412 109.2 1.2625 104.312 4.21915L7.97772 62.4904C3.33605 65.2981 0.5 70.3281 0.5 75.7528Z",
    fill: "#9035AF",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9625 166V109.341M75.9625 109.341L4 70.2492M75.9625 109.341L186 48",
    stroke: "white",
    strokeDasharray: "15 15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.452 7V57.5507M112.452 57.5507L7 116M112.452 57.5507L185 98.2283",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeDasharray: "15 15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerMIcon);
export default __webpack_public_path__ + "static/media/locker_m_icon.a0219236e758250b9627117b4ccda69e.svg";
export { ForwardRef as ReactComponent };